import Typography from '@material-ui/core/Typography';
import PageSegment from '../../../components/PageSegment';
import React, { useContext, useEffect } from 'react';
import WeeklyTargets from '../../../components/WeeklyTargets';
import MyPlan from '../../../components/MyPlan';
import Promotion from '../../../components/Promotion';
import Paper from '@material-ui/core/Paper';
import Card from '@material-ui/core/Card';
import { withStyles } from '@material-ui/core/styles';
import UserContext from '../../../contexts/UserContext';
import { useQuery, useMutation, useApolloClient } from 'react-apollo-hooks';
import { LIST_CURRENT_PERIOD } from '../../../common/graphql/ListCurrentPeriod';
import PeriodSelector from '../../../components/PeriodSelector';
import useDebounce from 'react-use/lib/useDebounce';
import getMemberPpr from '../../../common/graphql/GetMemberPeriodPlanResult';
import { UPDATE_PPR_PLAN } from '../../../common/graphql/UpdatePprPlan';
import { GET_PERIOD_PROMOTIONS } from '../../../common/graphql/GetPeriodPromotions';
import get from 'lodash/get';
import DashboardContext from '../../../contexts/DashboardContext';
import { Map } from 'immutable';
import TargetResultGauge from '../../../components/TargetResultGauge';
import { fetchLastWeekPeriodId } from '../MyResultsPage';
import PlanResults from '../MyResultsPage/PlanResults';
import ResultsProgress from '../../../components/ResultsProgress';
import useMemberPprs from '../../../hooks/useMemberPprs';
import Message from '../../../components/Message';
import PrivateBlock from '../../../components/PrivateBlock';
import useMyPprs from '../../../hooks/useMyPprs';

const styles = () => ({
  root: {
    // fontWeight: 'bold',
  },
  segment: {
    marginTop: 20,
  },
  segmentContent: {
    padding: 20,
  },
});

export default withStyles(styles)(function(props) {
  const { classes } = props;

  const { currentUser } = useContext(UserContext);
  const { state: dashboardState, service } = React.useContext(DashboardContext);
  React.useEffect(() => {
    service.send({ type: 'SHOW_PERIOD_SELECTOR' });
    // return () => service.send({ type: 'HIDE_PERIOD_SELECTOR' });
  }, []);
  const period = get(dashboardState, 'context.currentPeriod', {});
  const { id: periodId } = period;
  const store = get(dashboardState, 'context.currentStoreDetails') || {};
  const { id: storeId, type: storeType } = store;
  const variables = { periodId };

  if (storeId) variables.storeId = storeId;
  if (storeType) variables.storeType = storeType;

  const { data } = useQuery(GET_PERIOD_PROMOTIONS.query, {
    variables,
    skip: !periodId,
    fetchPolicy: 'network-only',
  });
  const memberId = currentUser.username;

  const { lastWeekPpr, ppr } = useMyPprs({ memberId, period });

  const storePromotions = get(data, `STORE_PROMOTION.promotions.items`, []);
  return (
    <div className={classes.root}>
      {!storeId && (
        <PrivateBlock allowedGroups={['Members', 'Management']}>
          <Message
            variant="warning"
            content={`You are not assigned to any store. Please ask your manager for assistance`}
          />
        </PrivateBlock>
      )}
      <PageSegment compact title={`This Week in Our Store (${period.name})`}>
        {storePromotions.map(promotion => {
          return (
            <React.Fragment key={promotion.id}>
              <Promotion {...{ promotion }} key={promotion.id} />
              <div className={classes.divider} />
              {/* <Divider className={classes.divider} /> */}
            </React.Fragment>
          );
        })}
      </PageSegment>
      <Typography variant="h5" style={{ margin: '20px 0' }}>
        Your Last Week's Results
      </Typography>
      <ResultsProgress ppr={lastWeekPpr} />
      <PageSegment title="This Week's Targets">
        <WeeklyTargets planResult={ppr} />
      </PageSegment>
    </div>
  );
});
